function overlayController(overlayService, configService) {

  const vm = this;
  vm.overlayGetter = overlayService.getOverlayState();
  vm.overlayToggle = overlayService.toggleOverlay;
  vm.overlayText = configService.messages.reference_help;
  vm.overlayButton = configService.messages.button;

  // Here to avoid loosing state when returning to the trackingcode page
  angular.element(document).ready(() => {

    const overlay = document.getElementById('overlay');
    angular.element(document.body).append(overlay);

  });

}

export default overlayController;


// WEBPACK FOOTER //
// ./src/components/overlay/overlay-template.controller.js